import React, { useCallback, useEffect, useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import { MYBIZ_DEFAULT_LOGOS, MYBIZ_LOGO_IMAGES, PATHS, RESOURCE_CONSTANT } from 'AppConstants';
import { logPageLoadEvents } from 'omnitures';
import BusinessPartners from './components/BusinessPartners/BusinessPartners';
import MyBizBlog from './components/MyBizBlog/MyBizBlog';
import ProductVideos from './components/ProductVideo/ProductVideo';
import BusinessDesign from './components/BusinessDesign/BusinessDesign';
import Benefits from './components/Benefits/Benefits';
import CustomerStories from './components/CustomerStories/CustomerStories';
import { getBlogsData,
	getProductVideos,
	getBusinessDesign,
	getBenefits,
	getCustomerStories } from '../../redux/actions/resourceActionDispatcher';
import SignUpFooter from '../../bizLanding/components/SignUpFooter/SignUpFooter';
import StickyFooter from '../../bizLanding/components/StickyFooter/StickyFooter';
import DisplayContext from 'UtilityComponents/displayContext';
import MetaTags from 'common/metaTags';
import { HiddenElem } from 'commonStyles';

const Resource = ({ isMobile }) => {
	const dispatch = useDispatch();
	const displayName = useContext(DisplayContext).isMobile;
	const isMobileView = isMobile || displayName == 'mobile';
	const history = useHistory();
	const { hash } = useLocation();

	useEffect(() => {
		loadData();
		handleScrolling();
		logPageLoadEvents(RESOURCE_CONSTANT.PAGE_VIEW);
	}, []);

	const loadData = () => {
		dispatch(getBlogsData());
		dispatch(getProductVideos());
		dispatch(getBusinessDesign());
		dispatch(getBenefits());
		dispatch(getCustomerStories());
	};

	const handleScrolling = () => {
		const hashUrl = hash.split('?');
		const hashComp = hashUrl[0];
		if (hashComp) {
			setTimeout(() => {
				scrollToComp(hashComp.replace('#', ''));
			});
		}
	};

	const scrollToComp = useCallback((link) => {
		if (link) {
			const element = document.getElementById(link);
			const newLocation = PATHS.RESOURCE_PAGE + '#' + link;
			try {
				if (element) {
					const bodyRect = document.body.getBoundingClientRect();
					const elemRect = element.getBoundingClientRect();
					const elementPosition = elemRect.top - bodyRect.top;
					const headerOffset = 0;
					const offsetPosition = elementPosition - headerOffset;

					window.scrollTo({
						top: offsetPosition,
						behavior: 'smooth'
					});
				}
				history.push(newLocation);
			} catch (error) {
				window.location = newLocation;
			}
		}
	}, [history]);

	return (
		<>
			<MetaTags titleTxt='Why myBiz suits the best need of Corporate/Business Travel' />
			<HiddenElem itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/SoftwareApplication`}>
				<meta itemProp='name' content='myBiz by MakeMyTrip' />
				<meta itemProp='applicationCategory' content='businesstravelApplication' />
				<meta itemProp='operatingSystem' content='ANDROID, IOS, Desktop' />
				<span itemProp='aggregateRating' itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/AggregateRating`}>
					<meta itemProp='ratingValue' content='4.5' />
					<meta itemProp='ratingCount' content='1937000' />
				</span>
				<span itemProp='offers' itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/Offer`}>
					<meta itemProp='price' content='0' />
					<meta itemProp='priceCurrency' content='INR' />
				</span>
			</HiddenElem>
			<HiddenElem itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/Organization`}>
				<meta itemProp='name' content='myBiz by MakeMyTrip' />
				<meta
					itemProp='description' content='myBiz, MakeMyTrip for Business is a one-stop expense & travel management solution for all corporate/business travel needs of micro to large enterprises.
						We are a preferred travel partner to more than 2.5 Lakh business travellers'
				/>
				<meta itemProp='logo' content={MYBIZ_LOGO_IMAGES.LOGO?.src || MYBIZ_DEFAULT_LOGOS.LOGO?.src || ''} />
				<meta itemProp='url' content='https://mybiz.makemytrip.com/' />
				<meta itemProp='sameAs' content='https://www.linkedin.com/showcase/makemytrip-for-business' />

				<span itemProp='address' itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/PostalAddress`}>
					<meta itemProp='streetAddress' content='MakeMyTrip India Pvt. Ltd., DLF Building No. 5 Tower B DLF Cyber City, DLF Phase 2. Sector 25' />
					<meta itemProp='addressLocality' content='Gurugram' />
					<meta itemProp='addressRegion' content='Haryana' />
					<meta itemProp='postalCode' content='122002' />
				</span>
				<span itemProp='contactPoint' itemScope itemType={`${PATHS.SEO_SCHEMA_URL}/ContactPoint`}>
					<meta itemProp='telephone' content='1860 500 8747' />
					<meta itemProp='contactType' content='Customer Care' />
					<meta itemProp='contactOption' content='TollFree' />
					<meta itemProp='areaServed' content='India' />
				</span>
			</HiddenElem>
			<BusinessPartners />
			<Benefits isMobile={isMobileView} />
			<BusinessDesign isMobile={isMobileView} />
			<ProductVideos isMobile={isMobileView} />
			<MyBizBlog isMobile={isMobileView} />
			<CustomerStories isMobile={isMobileView} />
			<SignUpFooter $bg='#fff' />
			{isMobileView && <StickyFooter />}
		</>
	);
};

export default Resource;
